// The export writers, loaded on demand.
//
// Nothing here is needed to open a lesson, edit it or present it — the HTML
// builder, the PowerPoint writer, the PDF writer and the LLM template are only
// reachable from the Export menu. Imported statically they sat in the initial
// bundle, so every visitor downloaded all of it before seeing a slide.
//
// pptxgenjs and fabric were already split out this way; these are the modules
// around them. Each loads once and is cached, so a second export costs nothing,
// and an export that runs several builders in a row waits only for the first.
//
// Every consumer is an async export handler, which is what makes this safe:
// `const { blockToHtml } = await loadHtmlExporter();` at the top of a handler
// leaves the body exactly as it was.

let htmlExporter = null;
let pptxExporter = null;
let pdfExporter = null;
let llmTemplate = null;

/** exportUtils: the HTML/canvas export builders (blockToHtml, image inlining). */
export const loadHtmlExporter = () => {
  if (!htmlExporter) htmlExporter = import('./exportUtils.js');
  return htmlExporter;
};

/** exportPptx: the PowerPoint writer (pptxgenjs itself is split again inside). */
export const loadPptxExporter = () => {
  if (!pptxExporter) pptxExporter = import('./exportPptx.js');
  return pptxExporter;
};

/** exportPdf: the PDF writer, which builds on the PowerPoint deck model. */
export const loadPdfExporter = () => {
  if (!pdfExporter) pdfExporter = import('./exportPdf.js');
  return pdfExporter;
};

/** llmTemplate: the blank-template payload handed to an LLM. */
export const loadLlmTemplate = () => {
  if (!llmTemplate) llmTemplate = import('./llmTemplate.js');
  return llmTemplate;
};

/** Test seam: forget what has been loaded so a case can observe the first load. */
export const __resetExporterCache = () => {
  htmlExporter = null;
  pptxExporter = null;
  pdfExporter = null;
  llmTemplate = null;
};
